var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 135"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#noResults_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 94q-4.285 0-7.143-2.768Q50 88.36 50 84.158q0-4.204 2.857-6.972 2.857-2.871 7.143-2.871t7.143 2.87Q70 79.955 70 84.158t-2.857 7.075Q64.285 94 60 94m-5.461-23.991a2 2 0 0 1-1.997-1.882l-2.417-41.01A2 2 0 0 1 52.12 25h15.47a2 2 0 0 1 1.998 2.1l-2.045 41.009a2 2 0 0 1-1.998 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEB87A",
    d: "m52.503 91.585.006.006C54.515 93.534 57.024 94.5 60 94.5s5.485-.966 7.49-2.91v.001l.007-.006c2.002-2.012 3.003-4.498 3.003-7.427s-1-5.383-3.006-7.328C65.49 74.818 62.98 73.815 60 73.815s-5.49 1.003-7.494 3.015c-2.006 1.945-3.006 4.4-3.006 7.328s1 5.415 3.003 7.427Zm-.46-23.429a2.5 2.5 0 0 0 2.496 2.353h11.007a2.5 2.5 0 0 0 2.497-2.376l2.045-41.008a2.5 2.5 0 0 0-2.496-2.625h-15.47a2.5 2.5 0 0 0-2.496 2.647z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "noResults_svg__a",
    width: 62,
    height: 121,
    x: 29,
    y: 14,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_872_83958"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_872_83958",
    result: "effect2_dropShadow_872_83958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_872_83958",
    result: "shape"
  })))));
};
export default SvgNoResults;